import React from 'react'

const MovieIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="movie-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 100, 150, 1)" />
          <stop offset="100%" stopColor="rgba(200, 50, 255, 1)" />
        </linearGradient>
        <filter id="movie-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <rect 
        x="2" 
        y="5" 
        width="20" 
        height="14" 
        rx="2" 
        stroke="url(#movie-gradient)" 
        strokeWidth="2"
        filter="url(#movie-glow)"
      />
      <path 
        d="M2 9H22M7 5L5 9M12 5L10 9M17 5L15 9M22 5L20 9" 
        stroke="url(#movie-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#movie-glow)"
      />
      <path 
        d="M10 13L14 15.5L10 18V13Z" 
        fill="url(#movie-gradient)" 
        opacity="0.8"
      />
    </svg>
  )
}

export default MovieIcon
